import type { ModuloWeb } from '../../nucleo/modulos-web';
import { CartaoPortal } from './CartaoPortal';
import { Acessos, Configuracao } from './Paginas';
import { i18n } from './i18n';

/**
 * Portal do Cliente (Onda 1): o lado da equipe. No menu Comercial, os acessos de todos os clientes e a configuração (termo de
 * uso); na ficha do cliente (Cadastros), a aba Portal com convite, revogação, documentos, recebidos, trilha e "Ver como o cliente".
 */
const modulo: ModuloWeb = {
  slug: 'portal',
  menu: 'comercial',
  ordem: 40,
  abas: [
    { chave: 'acessos', permissao: 'portal.ver', componente: Acessos },
    { chave: 'configuracao', permissao: 'portal.ver', componente: Configuracao },
  ],
  cartaoNaFichaCliente: CartaoPortal,
  i18n,
};

export default modulo;
